<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            size: {
                type: Number,
                default: 140
            },
            width: {
                type: Number,
                default: 7
            }
        }
    }
</script>

<template>
    <v-overlay v-model="loading">
        <v-progress-circular
            :size="size"
            :width="width"
            color="primary"
            indeterminate
        />
    </v-overlay>
</template>

